import React from 'react';
import { Navigate, Outlet, Route, Routes, useParams } from 'react-router-dom';
import { UserList } from './Backend/Users/UserList';
import { UserCreate } from './Backend/Users/UserCreate';
import { DoctorList } from './Backend/Contacts/DoctorList';
import DoctorCreate from './Backend/Contacts/DoctorCreate';
import { DoctorDetails } from './Backend/Contacts/DoctorDetails';
import CustomerProfileCreate from './Backend/Contacts/CustomerProfileCreate';
import { SpecializationList } from './Backend/Masters/Specialization/SpecializationList';
import { QualificationList } from './Backend/Masters/Qualification/QualificationList';
import { SymptomsList } from './Backend/Masters/Symptoms/symptomsList';
import { BrandList } from './Backend/Masters/Brand/BrandList';
import { DoctorServiceList } from './Backend/Masters/DoctorService/DoctorServiceList';
import { VendorTypeList } from './Backend/Masters/VendorType/VendorTypeList';
import { Specialization } from './Backend/Masters/Specialization/SpecializationCreate';
import { Qualification } from './Backend/Masters/Qualification/Qualification';
import { Symptoms } from './Backend/Masters/Symptoms/SymptomsCreate';
import { Brand } from './Backend/Masters/Brand/Brand';
import { DoctorService } from './Backend/Masters/DoctorService/DoctorService';
import { VendorType } from './Backend/Masters/VendorType/VendorType';
import { ChangePassword } from './Pages/ChangePassword/ChangePassword';
import VendorProfile from './Backend/Contacts/VendorProfile';
import { BookingList } from './Backend/Transactions/Booking/BookingList';
import { WalletsList } from './Backend/Transactions/Wallet/WalletList';
import { WithdrawalList } from './Backend/Transactions/Wallet/WithdrawelList';
import { VendorProfileSetUp } from './Pages/VendorProfileSetUp/VendorProfileSetUp';
import { MedicalCategoryList } from './Backend/Masters/MedicalCategory/MedicalCategoryList';
import { MedicalCategory } from './Backend/Masters/MedicalCategory/MedicalCategory';
import { CustomerPage, DoctorPage, VendorPage } from './Backend/Contacts/ContactPages';
import { CaseList } from './Backend/Cases/CaseList';
import { Analytics } from './Backend/Analytics/Analytics';
import { RolesAndPermissions } from './Backend/Roles/RolesAndPermissions';
import { RequirePermission } from './commonFunctions/RequirePermission';
import { IPermission } from './commonFunctions/PermissionManger';










interface PrivateRouteProps {
  token: string | null;
}

const guard = (page: string, element: React.ReactElement, action: keyof IPermission = "view") => (
  <RequirePermission page={page} action={action}>{element}</RequirePermission>
);

const LEGACY_CONTACT_TABS = ["/doctor/list", "/customer/list", "/vendor/list"];
const LegacyContactRedirect: React.FC = () => {
  const { tab } = useParams();
  return <Navigate to={LEGACY_CONTACT_TABS[Number(tab) || 0] || LEGACY_CONTACT_TABS[0]} replace />;
};

const PrivateRoute: React.FC<PrivateRouteProps> = ({ token }) => {
  // if (!token) {
  //   return token ? <Outlet /> : <Navigate to="/login" />;
  // }

  return (
    <Routes>
      {/* Each route is guarded by the role permission for its page: view (lists), add (create), edit (edit). */}
      <Route path="/user/list" element={guard("users", <UserList />)} />
      <Route path="/user/add" element={guard("users", <UserCreate />, "add")} />
      <Route path="/user/edit/:id" element={guard("users", <UserCreate />, "edit")} />

      <Route path="/analytics" element={guard("analytics", <Analytics />)} />
      <Route path="/case/list" element={guard("cases", <CaseList />)} />
      <Route path="/role/list" element={guard("roles", <RolesAndPermissions />)} />

      {/* Legacy combined contact list: redirect to the separate lists (tab 0 doctors, 1 customers, 2 vendors). */}
      <Route path="/contact/list/:tab?" element={<LegacyContactRedirect />} />
      <Route path="/contact/customer/list" element={<Navigate to="/customer/list" replace />} />

      <Route path="/doctor/list" element={guard("doctors", <DoctorPage />)} />
      <Route path="/doctor/profile/add/:userId" element={guard("doctors", <DoctorCreate />, "add")} />
      <Route path="/doctor/profile/edit/:id" element={guard("doctors", <DoctorCreate />, "edit")} />
      <Route path="/doctor/details" element={guard("doctors", <DoctorDetails />)} />

      <Route path="/customer/list" element={guard("customers", <CustomerPage />)} />
      <Route path="/customer/profile/add/:userId" element={guard("customers", <CustomerProfileCreate />, "add")} />
      <Route path="/customer/profile/edit/:id" element={guard("customers", <CustomerProfileCreate />, "edit")} />

      <Route path="/vendor/list" element={guard("vendors", <VendorPage />)} />
      <Route path="/vendor/profile/add/:userId" element={guard("vendors", <VendorProfile />, "add")} />
      <Route path="/vendor/profile/edit/:id" element={guard("vendors", <VendorProfile />, "edit")} />

      <Route path="/specialization/list" element={guard("specialization", <SpecializationList />)} />
      <Route path="/specialization/create" element={guard("specialization", <Specialization />, "add")} />
      <Route path="/specialization/edit/:id" element={guard("specialization", <Specialization />, "edit")} />

      <Route path="/qualification/list" element={guard("qualification", <QualificationList />)} />
      <Route path="/qualification/create" element={guard("qualification", <Qualification />, "add")} />
      <Route path="/qualification/edit/:id" element={guard("qualification", <Qualification />, "edit")} />

      <Route path="/symptoms/list" element={guard("symptoms", <SymptomsList />)} />
      <Route path="/symptoms/create" element={guard("symptoms", <Symptoms />, "add")} />
      <Route path="/symptoms/edit/:id" element={guard("symptoms", <Symptoms />, "edit")} />

      <Route path="/brand/list" element={guard("brand", <BrandList />)} />
      <Route path="/brand/create" element={guard("brand", <Brand />, "add")} />
      <Route path="/brand/edit/:id" element={guard("brand", <Brand />, "edit")} />

      <Route path="/doctor-service/list" element={guard("doctorService", <DoctorServiceList />)} />
      <Route path="/doctor-service/create" element={guard("doctorService", <DoctorService />, "add")} />
      <Route path="/doctor-service/edit/:id" element={guard("doctorService", <DoctorService />, "edit")} />

      <Route path="/vendor-type/list" element={guard("vendorType", <VendorTypeList />)} />
      <Route path="/vendor-type/create" element={guard("vendorType", <VendorType />, "add")} />
      <Route path="/vendor-type/edit/:id" element={guard("vendorType", <VendorType />, "edit")} />

      <Route path="/medical-category/list" element={guard("medicalCategory", <MedicalCategoryList />)} />
      <Route path="/medical-category/create" element={guard("medicalCategory", <MedicalCategory />, "add")} />
      <Route path="/medical-category/edit/:id" element={guard("medicalCategory", <MedicalCategory />, "edit")} />

      <Route path="/booking/list" element={guard("bookings", <BookingList />)} />
      <Route path="/wallet/list" element={guard("wallets", <WalletsList />)} />
      <Route path="/withdrawal/list" element={guard("withdrawals", <WithdrawalList />)} />

      {/* Available to every logged-in user */}
      <Route path="/changepassword" element={<ChangePassword />} />
    </Routes>
  );
};

export default PrivateRoute;
